var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('router-view'),(_vm.showBottomNav)?_c('bottom-nav'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }